export enum SegmentationBlockFeatureType {
  EWA_BLOCKING = "EWA_BLOCKING",
}

export interface ISegmentationBlockConfig {
  title?: string;
  reason?: string;
}

export interface ISegmentDetail {
  id: number;
  name: string;
  description: string;
  matched_employee_count: number | null;
}

export interface ISegmentationBlock {
  id: number;
  segments: ISegmentDetail[];
  feature_type: SegmentationBlockFeatureType;
  config?: ISegmentationBlockConfig;
  is_active: boolean;
  created_by: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
  } | null;
  created_at: string;
  updated_at: string;
  total_matched_employee_count: number | null;
}

export interface ISegmentationBlockListResponse {
  results: ISegmentationBlock[];
  count: number;
  pages: number;
}

export interface ICreateSegmentationBlockRequest {
  segments: number[];
  feature_type: SegmentationBlockFeatureType;
  config?: ISegmentationBlockConfig;
  is_active: boolean;
}

export interface IUpdateSegmentationBlockRequest {
  id: number;
  is_active: boolean;
}

export interface ISegmentationBlockHistoryEntry {
  id: number;
  timestamp: string;
  action: number;
  action_label: string;
  segment_name: string;
  actor_name: string;
  actor_email: string | null;
}

export interface ISegmentationBlockHistoryResponse {
  results: ISegmentationBlockHistoryEntry[];
  count: number;
  pages: number;
}

export interface SegmentationBlocksContextType {
  segmentationBlocks: ISegmentationBlock[];
  activeBlocks: ISegmentationBlock[];
  inactiveBlocks: ISegmentationBlock[];
  isLoading: boolean;
  isError: boolean;
  createBlock: (
    segmentIds: number[],
    title: string,
    reason: string,
    isActive: boolean
  ) => Promise<void>;
  updateBlock: (id: number, isActive: boolean) => Promise<void>;
  refetch: () => void;
  isCreating: boolean;
  isUpdating: boolean;
}
